const TreeNode = require('../TreeNode');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');

const Q_which_stance = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  // determine appropriate stance based on actor's AI priorities,
  // i.e. Tank above the DPS roles means defensive, otherwise offensive
  if (!Array.isArray(actor.ai.priorities) && typeof actor.ai.priorities === 'object') {
    actor.ai.priorities = Object.values(actor.ai.priorities);
  }
  const stance_dancing = BattleCalc.getEquippedAbility(actor, 'stance_dancing');
  const tank_priority = actor.ai.priorities.findIndex((ele) => ele === 'tank');
  const dps_ranged_priority = actor.ai.priorities.findIndex((ele) => ele === 'dps_ranged');
  const dps_close_priority = actor.ai.priorities.findIndex((ele) => ele === 'dps_close');
  const tank_priority_before_dps =
    tank_priority < dps_ranged_priority && tank_priority < dps_close_priority;

  node.branches.OFFENSIVE = new UseAbility(actor, 'stance_dancing', actor, 'offensive_stance');
  node.branches.DEFENSIVE = new UseAbility(actor, 'stance_dancing', actor, 'defensive_stance');

  node.query = function () {
    if (!stance_dancing) return null;
    else if (tank_priority_before_dps)
      return BattleCalc.getCondition(actor, 'defensive_stance')
        ? null
        : this.branches.DEFENSIVE.query();
    else if (!BattleCalc.getCondition(actor, 'offensive_stance'))
      return this.branches.OFFENSIVE.query();
    else return null;
  };

  return node;
};
module.exports = Q_which_stance;
